import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-my_s",
  "use": "icon-my_s-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-my_s\">\n  <path d=\"M512 61.44c113.11104 0 204.8 91.68896 204.8 204.8s-91.68896 204.8-204.8 204.8-204.8-91.68896-204.8-204.8S398.88896 61.44 512 61.44zM409.6 532.48h204.8c180.98176 0 327.68 146.69824 327.68 327.68v20.48a81.92 81.92 0 0 1-81.92 81.92H163.84a81.92 81.92 0 0 1-81.92-81.92v-20.48c0-180.98176 146.69824-327.68 327.68-327.68z\" fill=\"currentColor\" p-id=\"5734\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol